import { Outlet, useLocation } from 'react-router-dom'

import { FinanceSettingsPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import DimensionsSettings from './DimensionsSettings'

export interface FinanceSettingsOutletContextProps {
  hasCustomDimensionsFeature: boolean
  canManageCustomDimensions: boolean
  canManageCostCenters: boolean
}

const SettingsPage = () => {
  const { company } = useCurrentSession()
  const { data, error } = useQuery(FinanceSettingsPageDocument, {
    variables: { companyId: company.id },
  })
  const location = useLocation()

  const canManageCostCenters = data?.finance._policies.costCentersManageCostCenters.can ?? false
  const canManageCustomDimensions = data?.finance._policies.customDimensionsManage.can ?? false
  const hasCustomDimensionsFeature =
    data && (data.companies.featureAvailabilities[0]?.available ?? false)

  const loading = !data || !!error
  const showingMainPage = location.pathname.endsWith('settings/finance/dimensions')

  return (
    <ResponsivePage.Body
      variant="narrow"
      showHeader={false}
      loading={loading}
      error={error}
      authorized={canManageCustomDimensions || canManageCostCenters}
    >
      {showingMainPage && <DimensionsSettings />}
      <Outlet
        context={{ hasCustomDimensionsFeature, canManageCustomDimensions, canManageCostCenters }}
      />
    </ResponsivePage.Body>
  )
}

export default observer(SettingsPage)
